import { useEffect, useRef } from 'react';

type SegmentSeekerProps = {
  active: number;
  interval: number;
  tick: number;
  inView: boolean;
  className?: string;
  fillClassName?: string;
};

export function SegmentSeeker({
  active,
  interval,
  tick,
  inView,
  className = '',
  fillClassName = '',
}: SegmentSeekerProps) {
  const fillRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fill = fillRef.current;
    if (!fill) return;

    fill.style.transition = 'none';
    fill.style.width = '0%';
    void fill.offsetWidth;

    if (inView) {
      fill.style.transition = `width ${interval}ms linear`;
      fill.style.width = '100%';
    }
  }, [active, interval, inView, tick]);

  return (
    <div className={`segment-seeker${className ? ` ${className}` : ''}`} aria-hidden="true">
      <div ref={fillRef} className={`segment-seeker-fill${fillClassName ? ` ${fillClassName}` : ''}`} />
    </div>
  );
}
